import type { ReactNode } from "react";
import { TopBar } from "./TopBar";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="page-shell" style={{ flexDirection: "column" }}>
      <TopBar />
      <div className="page-content">{children}</div>
    </div>
  );
}
